import React from 'react';
import { Link } from 'react-router-dom';
import SchoolPageHeader from '../../components/school/SchoolPageHeader';
import { Icons } from '../../lib/Icons';

export default function EHCNAIndexPage() {
  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <SchoolPageHeader
        title="EHCNA Request Workflow (Non-EHCP)"
        description="Build a local-authority EHC needs assessment request from graduated response evidence, costed provision, and impact history."
        icon={Icons.ClipboardDocumentCheck}
        breadcrumbs={[{ label: 'Dashboard', href: '/dashboard' }, { label: 'EHCNA' }]}
        actions={[{ label: 'Start New Request', href: '/ehcna/new' }]}
      />

      <div className="grid gap-4 md:grid-cols-3">
        {[
          {
            title: 'Evidence Readiness',
            body: 'Check APDR history, intervention impact, targets, and professional report evidence.',
          },
          {
            title: 'Graduated Response + Costing',
            body: 'Confirm support provided over time and summarise costed provision before request generation.',
          },
          {
            title: 'Generate EHCNA Draft',
            body: 'Generate non-diagnostic journey text, SMART outcomes, and assess-plan-do-review narrative.',
          },
        ].map((step, idx) => (
          <div key={step.title} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <p className="text-xs font-semibold uppercase tracking-wide text-indigo-600">Step {idx + 1}</p>
            <h2 className="mt-2 text-lg font-semibold text-slate-900">{step.title}</h2>
            <p className="mt-1 text-sm text-slate-600">{step.body}</p>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-900">Pilot usage guidance</h2>
        <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-slate-600">
          <li>EHCNA flow is only for students without an EHCP.</li>
          <li>Start from a student&apos;s ISP profile using <strong>Start EHCNA Request</strong>, or pick a student below.</li>
          <li>Evidence, eligibility, and costed provision are pulled automatically from interventions, session logs, targets, and APDR history.</li>
          <li>Demo tip: seed data includes <strong>Ethan Davis</strong> (Year 3, ASD) as a fully populated EHCNA example.</li>
          <li>Use generated draft content as a starting point and quality-check before LA submission.</li>
        </ul>
        <div className="mt-5">
          <Link to="/ehcna/new" className="inline-flex items-center rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700">
            Open EHCNA Builder
          </Link>
        </div>
      </div>
    </div>
  );
}
